export default __webpack_public_path__ + "static/Metropolis-Regular-6f302113f4097fa951a6b27c3cf6981f.woff2";